"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationTokenType = void 0;
/**
 * Validation Token Types
 */
var ValidationTokenType;
(function (ValidationTokenType) {
    ValidationTokenType["Confirmation"] = "confirmation";
    ValidationTokenType["ResetPassword"] = "reset-password";
    ValidationTokenType["GroupInvitation"] = "group-invitation";
    ValidationTokenType["PerformerOnboarding"] = "performer-onboarding";
    ValidationTokenType["CharacterPhotoCapture"] = "character-photo-capture";
})(ValidationTokenType || (exports.ValidationTokenType = ValidationTokenType = {}));
//# sourceMappingURL=validation-token-types.js.map